<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group
            label="Cliente"
            label-for="cliente"
            :label-cols="labelCols"
            horizontal>
            <b-input-group>
              <b-input-group-append 
                  class="filter-search-icons"
                  v-if="!filtro.filtroNumero"
                  @click="seleccionarCliente">
                <b-input-group-text>
                  <i :class="{ 'fa fa-search': !filtro.cliente,
                                'fa fa-remove': filtro.cliente  }"></i>
                </b-input-group-text>
              </b-input-group-append>
              <b-form-input 
                id="cliente"
                :value="clienteNombre"
                readonly
                type="text"/>
            </b-input-group>
          </b-form-group>
          
          <label v-if="opcionDashboardPropio" class="subtitulo">Dashboard General</label>

          <b-form-group
            v-if="opcionDashboardPropio"
            label="Consultar Dashboard Gral."
            :label-cols="labelCols"
            horizontal>
            <b-form-checkbox 
                id="tareasTerceros"
                v-model="filtro.tareasTerceros"
                :value= "Boolean(true)"
                :unchecked-value= "Boolean(false)">
            </b-form-checkbox>
          </b-form-group>

          <app-usuario
            v-if="opcionDashboardPropio"
            label="Usuario"
            description="Dashboard del usuario"
            :nombre="usuarioNombre"
            :lista="usuariosList"
            :label-cols="labelCols"
            labelOption="Todos los usuarios"
            :nullDisabled="false"
            :disabled="seleccionUsuarioDisabled"
            @updated="usuarioActualizado">
          </app-usuario>

          <b-form-group
            label-for="incluirFinalizadas"
            :label-cols="labelCols">
            <b-form-checkbox 
                id="incluirFinalizadas"
                v-model="filtro.incluirFinalizadas"
                :value=true
                :unchecked-value=false>
                Incluir Tareas Finalizadas
            </b-form-checkbox>
          </b-form-group>
        </b-form>
        <br>
        <div class="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="filtrar">Filtrar</b-button>
          <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="limpiarFiltro">Limpiar</b-button>
        </div>
      </b-collapse>
    </b-card>

    <b-modal ref="searchClienteModal" 
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-cliente
        :incluirInactivos="true"
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>
  </div>
</template>

<script>
import SearchCliente from '../clientes/SearchList.vue';
import Usuario from '../shared/abmSelect.vue';
import moment from 'moment';

export default {
  components: {
    appSearchCliente: SearchCliente,
    appUsuario: Usuario
  },
  props: {
    cliente: {
      type: Object,
      default: null
    },
    tareasTerceros: {
      type: Boolean,
      default: false
    },
    usuario: {
      type: Object,
      default: null
    },
    opcionDashboardPropio: {
      type: Boolean,
      default: false
    },
    incluirFinalizadas: {
      type: Boolean,
      default: false
    }   
  },
  data() {
    return {
      filtro: {
        cliente: null,
        tareasTerceros: false,
        usuario: null,
        incluirFinalizadas: false
      },

      showOpcionesFiltro: false,
      labelCols: 2,

      usuarios: [],
      usuariosList: [],
      loadingUsuarios: false,
    }
  },
  computed: {
    'clienteNombre': function() {
      return this.filtro.cliente? this.filtro.cliente.nombre.trim() : '';
    },
    'usuarioNombre': function() {
      return this.filtro.usuario? this.filtro.usuario.nombreCompleto.trim() : null;
    },
    seleccionUsuarioDisabled() {
      if (this.opcionDashboardPropio) {
        return !this.filtro.tareasTerceros;
      }
      return false;
    }
  },
  created() {
      this.filtro.cliente = this.cliente;
      this.filtro.tareasTerceros = this.tareasTerceros;
      this.filtro.usuario = this.usuario;
      this.filtro.incluirFinalizadas = this.incluirFinalizadas;

      this.getDatosAdicionales();
  },
  methods: {
    getDatosAdicionales() {
      this.loadingUsuarios = true;
      this.$store.dispatch('usuarios/getUsuariosAsignarBrief')
        .then(() => {
          this.usuarios = this.$store.getters['usuarios/list'];
          this.usuariosList = this.$store.getters['usuarios/selectList'];
          this.loadingUsuarios = false;
        })
    },
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
      this.filtro.cliente = null;
      this.filtro.tareasTerceros = false;
      this.filtro.usuario = null;
      this.filtro.incluirFinalizadas = false;
    },
    seleccionarCliente() {
      if (this.filtro.cliente) {
        this.filtro.cliente = null;
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    clienteSeleccionado(cliente) {
      this.filtro.cliente = cliente;
      this.$refs.searchClienteModal.hide();
    },
    usuarioActualizado(usuarioNombre) {
      if (!this.loadingUsuarios) {
        this.filtro.usuario= null;

        if (usuarioNombre) {
          this.filtro.usuario = this.getSelectedByNombreCompleto(this.usuarios, usuarioNombre);
        }
      }
    },
    getSelectedByNombreCompleto (list, nombre) {
        var selected = {};
        if (nombre) {
          for ( let key in list ){
            const element = list[key];
            if (element.nombreCompleto.trim() == nombre.trim() ){
              selected = element;
            }
          }
        }
        return selected;
    },
  },
  watch: {
  }    
}
</script>

<style>
  .briefs-tareas-list .card-filter label.subtitulo {
    font-weight: 600;
    margin-top: 10px;
    margin-bottom: 15px;
  }
  .briefs-tareas-list .card-filter .custom-checkbox {
    top: 8px;
  }
</style>
